// extracted by mini-css-extract-plugin
module.exports = {"coursesNav":"MyCoursesNav_coursesNav__3r7Fo","inactive":"MyCoursesNav_inactive__1rXtL","active":"MyCoursesNav_active__2aqQR"};